import { motion } from "framer-motion";
import { STATS } from "../lib/data";

const ABOUT_IMG =
  "https://images.unsplash.com/photo-1703014299011-e057352c0e87?crop=entropy&cs=srgb&fm=jpg&q=85";

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative bg-black border-t border-neutral-900 py-24 md:py-40 overflow-hidden"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16">
          {/* Left: overline + huge text */}
          <div className="md:col-span-7">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="text-[10px] uppercase tracking-[0.4em] text-neutral-500 mb-8"
            >
              — Our Mission
            </motion.div>
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7 }}
              data-testid="about-title"
              className="font-display uppercase text-5xl md:text-7xl lg:text-8xl leading-[0.9] text-white"
            >
              Uniting cultures
              <br />
              through{" "}
              <span className="aa-outline-text">elite</span>
              <br />
              competition.
            </motion.h2>

            <motion.p
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2, duration: 0.6 }}
              className="text-neutral-400 text-base md:text-lg leading-relaxed max-w-xl mt-10 font-light"
            >
              AfroAm Association is more than a league. We are a movement
              binding two continents through the language of the game. From
              dusty courts in Lagos to legendary blacktops in Brooklyn — every
              dribble carries the story of a people, a diaspora, a future
              written in motion.
            </motion.p>
          </div>

          {/* Right: image card */}
          <div className="md:col-span-5">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="relative border border-neutral-800 aspect-[4/5] overflow-hidden"
            >
              <img
                src={ABOUT_IMG}
                alt="The Court"
                className="w-full h-full object-cover grayscale"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/10 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
                <div className="text-[10px] uppercase tracking-[0.35em] text-neutral-400">
                  Field Notes
                </div>
                <div className="font-display text-2xl md:text-3xl uppercase text-white mt-2">
                  The Court Knows
                </div>
              </div>
            </motion.div>
          </div>
        </div>

        {/* Stats strip */}
        <div className="mt-20 md:mt-28 border-t border-neutral-900">
          <div
            data-testid="about-stats"
            className="grid grid-cols-2 md:grid-cols-4 divide-y md:divide-y-0 md:divide-x divide-neutral-900 border-b border-neutral-900"
          >
            {STATS.map((s, i) => (
              <motion.div
                key={s.label}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.08, duration: 0.6 }}
                className="py-10 px-6 md:px-10"
                data-testid={`stat-${s.label.toLowerCase()}`}
              >
                <div className="font-display text-5xl md:text-6xl text-white leading-none">
                  {s.value}
                </div>
                <div className="text-[10px] uppercase tracking-[0.3em] text-neutral-500 mt-3">
                  {s.label}
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
